import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CommonStyleSet from '@/components/page/pageSet/CommonStyleSet.vue';
import ChartShowSet from '@/components/page/pageSet/ChartShowSet.vue';
import OneFieldSet from '@/components/page/pageSet/OneFieldSet.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'TabPageSet',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    ImageList: {
      type: Array
    },
    tableId: {
      type: Number
    }
  },
  data: function data() {
    return {
      showNum: 0,
      //控制设置内容显示隐藏
      //弹出层的打开状态
      addDialogFlag: false,
      addDialogType: 0,
      blockArr: [{
        blockCnName: "样式设置",
        fieldArr: [{
          cnName: "跳转形式",
          enName: "jumpWay",
          type: 1,
          dicList: [{
            label: "平铺",
            value: "1"
          }, {
            label: "更多跳转",
            value: "2"
          }, {
            label: "选项卡",
            value: "4"
          }, {
            label: "选项卡右侧平铺",
            value: "6"
          }, {
            label: "选项卡后平铺",
            value: "5"
          }, {
            label: "顶部平铺",
            value: "7"
          }]
        }, {
          cnName: "选项卡屏幕占比lg",
          enName: "tabScreenLg",
          type: 2,
          filterName: 'jumpWay',
          filterValue: '4',
          filterType: 1
        }, {
          cnName: "选项卡屏幕占比xl",
          enName: "tabScreenXl",
          type: 1,
          filterName: 'jumpWay',
          filterValue: '4',
          filterType: 1
        }, {
          cnName: "是否标头",
          enName: "setHeaderHide",
          type: 1,
          dicList: [{
            label: "不显示",
            value: "1"
          }, {
            label: "显示",
            value: "2"
          }]
        }, {
          cnName: "标头Icon",
          enName: "titleIcon",
          type: 1,
          dicList: [{
            label: "不显示",
            value: "1"
          }, {
            label: "显示",
            value: "2"
          }]
        }, {
          cnName: "是否显示记录数",
          enName: "ifShowTotal",
          type: 1,
          dicList: [{
            label: "显示",
            value: "1"
          }, {
            label: "不显示",
            value: "2"
          }]
        }, {
          cnName: "选项卡样式设置",
          enName: "newTabLine",
          type: 1,
          filterName: 'jumpWay',
          filterValue: '4',
          filterType: 1,
          dicList: [{
            label: "iconBlock",
            value: "iconBlock"
          }, {
            label: "no-line",
            value: "no-line"
          }, {
            label: "line",
            value: "line"
          }, {
            label: "排行榜",
            value: "paihang"
          }, {
            label: "card类型标签页",
            value: "tabPage"
          }, {
            label: "block",
            value: "block"
          }, {
            label: "fillet",
            value: "fillet"
          }, {
            label: "intervalTab",
            value: "intervalTab"
          }]
        }, {
          cnName: "点击跳转",
          type: 2,
          filterName: 'jumpWay',
          filterValue: '2',
          filterType: 1,
          inputArr: [{
            cnName: "跳转的对象ID",
            enName: "clickTableId",
            placeholder: "跳转的对象ID"
          }, {
            cnName: "跳转的PageID",
            enName: "clickPageId",
            placeholder: "跳转的PageID"
          }, {
            cnName: "跳转的PageType",
            enName: "clickPageType",
            placeholder: "跳转的PageType"
          }]
        }]
      }],
      cssBlockIndex: -1,
      cssButtonIndex: -1,
      cssDialogFlag: false,
      cssBlockArr: [{
        blockCnName: "样式设置",
        filterName: 'jumpWay',
        filterValue: '4,5,6',
        filterType: 1,
        buttonArr: [{
          cnName: "平铺选项卡样式",
          enName: "tabPageFieldNameStyleSet",
          type: 1
        }, {
          cnName: "选项卡名称样式",
          enName: "tabPageTabTitleCommonStyleSet",
          type: 1
        }, {
          cnName: "选项卡更多标头样式",
          enName: "tabPageTabMoreCommonStyleSet",
          type: 1
        }, {
          cnName: "选项卡整体样式设置",
          enName: "tabPageTabsBoxCommonStyleSet",
          type: 1
        }, {
          cnName: "选项卡tabs组件样式设置",
          enName: "tabPageTabsCommonStyleSet",
          type: 1
        }, {
          cnName: "选项卡tab未选中样式设置",
          enName: "tabPageTabDefaultCommonStyleSet",
          type: 1
        }, {
          cnName: "选项卡tab选中样式设置",
          enName: "tabPageTabCheckCommonStyleSet",
          type: 1
        }]
      }, {
        blockCnName: "块的循环BOX样式",
        // filterName:'jumpWay',filterValue:'4,5,6',filterType:1,
        buttonArr: [{
          cnName: "块的循环BOX样式",
          enName: "tabPageForBoxStyleSet",
          type: 1
        }, {
          cnName: "字段外层样式设置",
          enName: "tabPageFieldStyleSet",
          type: 1
        }, {
          cnName: "字段name样式设置",
          enName: "tabPageFieldNameStyleSet",
          type: 1
        }, {
          cnName: "字段value样式设置",
          enName: "tabPageFieldValueStyleSet",
          type: 1
        }, {
          cnName: "字段name前图标样式设置",
          enName: "tabPageFieldIconStyleSet",
          type: 1
        }, {
          cnName: "平铺选项卡样式",
          enName: "lookTileTabsCommonStyleSet",
          type: 1,
          filterName: 'jumpWay',
          filterValue: '1',
          filterType: 1
        }]
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  watch: {},
  computed: {},
  components: {
    CommonStyleSet: CommonStyleSet,
    ChartShowSet: ChartShowSet,
    OneFieldSet: OneFieldSet
  },
  methods: {
    openCssBlockDialog: function openCssBlockDialog(cssBlockIndex, cssButtonIndex) {
      var that = this;
      that.cssBlockArr.forEach(function (cssBlockOne) {
        cssBlockOne.buttonArr.forEach(function (cssButtonOne) {
          if (!that.value[cssButtonOne.enName]) {
            that.$set(that.value, cssButtonOne.enName, {});
          }
        });
      });
      that.cssBlockIndex = cssBlockIndex;
      that.cssButtonIndex = cssButtonIndex;
      that.cssDialogFlag = true;
    }
  }
};